
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class EditTagLoader extends Vue {}
